module.exports = __webpack_public_path__ + "img/pro-photo10-1.f081d6ef.png";